import React from 'react';

import {IContentfulParagraphProps} from './IContentfulParagraph';

const ContentfulParagraph = ({children}: IContentfulParagraphProps) => {
	if (!children) {
		return null;
	}

	const childrenArray = React.Children.toArray(children).filter(Boolean);

	if (!childrenArray.length) {
		return (
			<p>
				<br />
			</p>
		);
	}

	// If it's just used for grouping, don't render a paragraph tag
	const isGrouper = childrenArray.every((child: React.ReactElement) => !!child?.props?.data?.target?.sys?.id);

	if (isGrouper) {
		return <>{children}</>;
	}

	return <p>{children}</p>;
};

export default ContentfulParagraph;
